import styled from 'styled-components';

interface ItemProps {
  readonly width?: string;
  readonly lineBetweenTitle: boolean;
}

export const InfoBannerContainer = styled.div`
  display: flex;
`;

export const InfoBannerItem = styled.div<ItemProps>`
  min-width: ${props => (props.width ? props.width : '110px')};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;
  border-right: 1px solid rgba(93, 110, 129, 0.23);
  &:first-of-type {
    padding-left: 0;
  }

  &:last-of-type {
    padding: ${props => (!props.lineBetweenTitle && 0)};
    border-right: ${props => (props.lineBetweenTitle && 'none')};
  }
`;

export const InfoBannerTitle = styled.div<ItemProps>`
  align-items: center;
  color: var(--DarkGray);
  display: flex;
  font-size: 17px;
  font-weight: 600;
  height: 100%;
  padding-right: ${props => (props.lineBetweenTitle ? '22px' : '0px')};
  border-right: ${props => (props.lineBetweenTitle && '1px solid rgba(93, 110, 129, 0.23)')};
`;

export const InfoBannerNumber = styled.div`
  color: var(--DarkGray);
  display: inline-block;
  padding-right: 8px;
  font-weight: 600;
  font-size: 30px;
`;

export const InfoBannerText = styled.div`
  color: var(--DarkGray);
  display: inline-block;
  font-size: 12px;
  max-width: 50px;
`;
